/**
 * Utility functions for managing cookies during logout
 */

/**
 * Clears all cookies from the browser
 * This is necessary because JSESSIONID cookies created during OAuth2 flow
 * persist even when the backend is configured as stateless
 */
export const clearAllCookies = () => {
  // Clear all cookies by setting them to expire in the past
  document.cookie.split(";").forEach(function(c) { 
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
  });
  
  // Specifically clear JSESSIONID cookies for different paths and domains
  const cookiePaths = ['/', '/api', '/aas'];
  const domains = [window.location.hostname, `.${window.location.hostname}`];
  
  cookiePaths.forEach(path => {
    domains.forEach(domain => {
      // Clear JSESSIONID for specific path and domain combinations
      document.cookie = `JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain};`;
      document.cookie = `JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
      
      // Also try with secure flag for HTTPS
      if (window.location.protocol === 'https:') {
        document.cookie = `JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}; secure;`;
        document.cookie = `JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; secure;`;
      }
    });
  });
};

/**
 * Clears all sessionStorage items
 * This is crucial because the application stores user session data in sessionStorage
 * that persists across page reloads and needs to be cleared on logout
 */
export const clearAllSessionStorage = () => {
  // Clear all sessionStorage items
  sessionStorage.clear();
};

/**
 * Comprehensive logout cleanup - clears all storage mechanisms
 * This is the main function to call during logout to ensure complete session cleanup
 */
export const clearAllSessionData = () => {
  // Clear cookies (including JSESSIONID)
  clearAllCookies();
  
  // Clear sessionStorage (user session data)
  clearAllSessionStorage();
  
  // Note: localStorage is handled by the Redux reducer
  // Note: Redux state is reset by the LOGOUT action
};

/**
 * Clears a specific cookie by name
 * @param {string} cookieName - The name of the cookie to clear
 * @param {string} path - The path of the cookie (default: '/')
 * @param {string} domain - The domain of the cookie (default: current domain)
 */
export const clearCookie = (cookieName, path = '/', domain = window.location.hostname) => {
  const domains = [domain, `.${domain}`];
  
  domains.forEach(d => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${d};`;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
    
    if (window.location.protocol === 'https:') {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${d}; secure;`;
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; secure;`;
    }
  });
};
